/** Stored image variants (spec §10.1, §8): long edge in px, the kept GIF, and the 640 px board thumbnail. */
export const STORED_VARIANTS = ['256', '1024', '2560', 'original', '640'] as const;
export type StoredVariant = (typeof STORED_VARIANTS)[number];

/** Largest body accepted per variant upload (Worker and SQL agree on these). */
export const MAX_VARIANT_BYTES: Record<StoredVariant, number> = {
  '256': 10_485_760,
  '1024': 10_485_760,
  '2560': 10_485_760,
  original: 15_728_640,
  '640': 2_097_152,
};

/** A GIF up to this size keeps its animated original; a bigger one is stored as a still image. */
export const GIF_ORIGINAL_MAX = 15_728_640;

/** Uploads stop when storage would pass this share of the organization's quota (spec §I-P4). */
export const QUOTA_BLOCK_RATIO = 0.8;

const ascii = (b: Uint8Array, from: number, to: number) => String.fromCharCode(...b.subarray(from, to));

export const isWebp = (b: Uint8Array): boolean => b.length >= 12 && ascii(b, 0, 4) === 'RIFF' && ascii(b, 8, 12) === 'WEBP';
export const isGif = (b: Uint8Array): boolean => b.length >= 6 && (ascii(b, 0, 6) === 'GIF87a' || ascii(b, 0, 6) === 'GIF89a');

export const variantMime = (v: StoredVariant): 'image/webp' | 'image/gif' => (v === 'original' ? 'image/gif' : 'image/webp');
